import { resetStudySession } from "../study/studyIdentity";

export default function SessionControls() {
  return (
    <div className="mt-6 max-w-md border-t border-white/10 pt-4 text-xs text-gray-400">
      <div className="flex flex-wrap gap-2">
        <button type="button" onClick={() => resetStudySession()}
          className="min-h-9 rounded-lg border border-white/20 px-3 py-2 text-gray-200 hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white">
          Start new session
        </button>
        <button type="button" onClick={() => resetStudySession({ newParticipant: true })}
          className="min-h-9 rounded-lg border border-white/20 px-3 py-2 text-gray-200 hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white">
          New participant
        </button>
      </div>
      <p className="mt-2 leading-relaxed">Start with empty preferences and ratings. Previously submitted responses are kept.</p>
    </div>
  );
}
